module.exports = __webpack_public_path__ + "assets/images/record_bg@2x-d553d4137a311054db6f47d3976e1b6a.jpg";